// Per-vendor personalisation of outreach drafts. Hotel chains share central
// reservation inboxes, so every hotel email/WhatsApp names the exact property.

const insertAfterLocation = (body, line, marker = '• Location:') => {
  const lines = body.split('\n').filter(l => !l.trim().startsWith('• Property:'));
  const i = lines.findIndex(l => l.trim().startsWith(marker));
  if (i >= 0) lines.splice(i + 1, 0, line);
  else lines.unshift(line);
  return lines.join('\n');
};

export const personaliseEmailBody = (body, vendor) => {
  if ((vendor?.type || '').toLowerCase() !== 'hotel' || !vendor?.name) return body;
  return insertAfterLocation(body, `• Property: ${vendor.name}`);
};

// Fallback for the single BCC email (Gmail not connected): one shared body,
// so list every picked property and let each recipient identify theirs.
export const personaliseEmailBodyMulti = (body, vendors) => {
  const hotels = (vendors || []).filter(v => (v.type || '').toLowerCase() === 'hotel' && v.name);
  if (!hotels.length) return body;
  if (hotels.length === 1) return personaliseEmailBody(body, hotels[0]);
  const names = hotels.map(v => v.name).join(' / ');
  return insertAfterLocation(body, `• Property: as addressed to your property — ${names}`);
};

export const personaliseWhatsAppText = (text, vendor) => {
  if ((vendor?.type || '').toLowerCase() !== 'hotel' || !vendor?.name) return text;
  const propLine = `🏨 *Property:* ${vendor.name}`;
  const lines = text.split('\n').filter(l => !l.startsWith('🏨 *Property:*'));
  const i = lines.findIndex(l => l.startsWith('📍 *Location:*'));
  if (i >= 0) lines.splice(i + 1, 0, propLine);
  else lines.splice(1, 0, propLine);
  return lines.join('\n');
};
